import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/constants";
import useSeo from "@/lib/useSeo";

export default function Impressum() {
    useSeo({
        title: "Impressum – Alpen Reinigung Innsbruck",
        description:
            "Impressum von Alpen Reinigung – Reinigungsservice Faisal Safi, Schusterbergweg 72, 6020 Innsbruck. UID, Steuernummer und Kontaktdaten.",
        path: "/impressum",
    });
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
            <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-[#C9D3E1] hover:text-white mb-8"
            >
                <ArrowLeft className="h-4 w-4" />
                Zurück zur Startseite
            </Link>
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                Rechtliches
            </p>
            <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                Impressum
            </h1>
            <div className="mt-8 space-y-6 text-[#C9D3E1] leading-relaxed">
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">Angaben gemäß § 5 ECG / § 24 MedienG</h2>
                    <p>
                        {COMPANY.legalName}
                        <br />
                        Inhaber: {COMPANY.owner}
                        <br />
                        {COMPANY.address.street}
                        <br />
                        {COMPANY.address.city}
                        <br />
                        {COMPANY.address.country}
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">Kontakt</h2>
                    <p>
                        Telefon:{" "}
                        <a
                            href={`tel:${COMPANY.phoneTel}`}
                            className="text-[#7BD3FF] hover:text-white"
                        >
                            {COMPANY.phone}
                        </a>
                        <br />
                        E-Mail:{" "}
                        <a
                            href={`mailto:${COMPANY.email}`}
                            className="text-[#7BD3FF] hover:text-white"
                        >
                            {COMPANY.email}
                        </a>
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">Unternehmensdaten</h2>
                    <p className="font-mono text-sm">
                        UID-Nummer: {COMPANY.atu}
                        <br />
                        Steuernummer: {COMPANY.stNr}
                        <br />
                        DG-Nummer: {COMPANY.dgNr}
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        Unternehmensgegenstand
                    </h2>
                    <p>
                        Reinigungsdienstleistungen für Privat- und Gewerbekunden:
                        Gebäudereinigung, Fassadenreinigung, Fensterreinigung,
                        Unterhaltsreinigung und Spezialreinigung.
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        Aufsichtsbehörde / Gewerbebehörde
                    </h2>
                    <p>Magistrat der Stadt Innsbruck</p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">
                        Online-Streitbeilegung
                    </h2>
                    <p>
                        Die Europäische Kommission stellt eine Plattform zur
                        Online-Streitbeilegung (OS) bereit:{" "}
                        <a
                            href="https://ec.europa.eu/consumers/odr"
                            target="_blank"
                            rel="noreferrer"
                            className="text-[#7BD3FF] hover:text-white underline underline-offset-2"
                        >
                            ec.europa.eu/consumers/odr
                        </a>
                        .
                    </p>
                </section>
                <section>
                    <h2 className="text-white font-heading text-lg mb-2">Haftungsausschluss</h2>
                    <p>
                        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
                        Haftung für die Inhalte externer Links. Für den Inhalt der
                        verlinkten Seiten sind ausschließlich deren Betreiber
                        verantwortlich.
                    </p>
                </section>
            </div>
        </div>
    );
}
